const ACCENTED: Record<string, string> = {
  a: "á", e: "é", i: "í", o: "ó", u: "ú", y: "ý", c: "ç", n: "ñ",
  A: "Á", E: "É", I: "Í", O: "Ó", U: "Ú", Y: "Ý", C: "Ç", N: "Ñ",
}

/**
 * Turns an English ICU message into a pseudo-locale one: accented letters, about
 * 40% longer, wrapped in brackets. Placeholders and plural selectors are left
 * alone. Hardcoded strings stay plain English, and anything that can't hold the
 * longer text overflows, so both are easy to spot.
 */
export function pseudoLocalize(message: string): string {
  let depth = 0
  let out = ""
  let letters = 0
  for (const ch of message) {
    if (ch === "{") depth += 1
    // Depth 0 is plain text; depth 2 is the body of a plural/select branch.
    const translatable = depth === 0 || depth === 2
    if (translatable && ACCENTED[ch]) out += ACCENTED[ch]
    else out += ch
    if (translatable && /[a-z]/i.test(ch)) letters += 1
    if (ch === "}") depth = Math.max(0, depth - 1)
  }
  return `[${out}${"~".repeat(Math.ceil(letters * 0.4))}]`
}

export function pseudoLocalizeAll(messages: Record<string, string>): Record<string, string> {
  return Object.fromEntries(Object.entries(messages).map(([key, value]) => [key, pseudoLocalize(value)]))
}
